import React from "react";
import Header from "../../../../components/Header";
import { Spin } from "antd";
import MHeader from "../../../../components/MHeader";
import { useHistory } from "react-router-dom";
import useDeviceType from "../../../../Utils/useDeviceType";

export default function CourseSpin() {
    const history = useHistory();
    const { isPC } = useDeviceType();

    return (
        <div>
            {isPC && <Header />}
            {!isPC && <MHeader title="课程内容" goBack={history.goBack} />}

            <Spin>
                <div style={{ textAlign: "center", height: 400 }} />
            </Spin>
        </div>
    );
}
